module.exports = __webpack_public_path__ + "img/galeria_salas_de_aula (7).0e6cdbd2.jpeg";